import { TFunction } from 'i18next';
import { PermissionLevel } from '@piwikpro/access-control-crate';

const OPTION_ORDER = ['manage', 'edit-publish', 'edit', 'view', 'no-access'] as const;

const PERMISSION_OPTION_DATA_ID = 'user-permissions-option';

export type PermissionOptionsKind = 'app' | 'meta-site';

const DESCRIPTION_KEYS: Record<PermissionOptionsKind, Partial<Record<typeof OPTION_ORDER[number], string>>> = {
  app: {
    manage: 'users.permissions.levels.app.manage.description',
    'edit-publish': 'users.permissions.levels.app.edit-publish.description',
    edit: 'users.permissions.levels.app.edit.description',
    view: 'users.permissions.levels.app.view.description',
    'no-access': 'users.permissions.levels.app.no-access.description',
  },
  'meta-site': {
    manage: 'users.permissions.levels.meta-site.manage.description',
    edit: 'users.permissions.levels.meta-site.edit.description',
    view: 'users.permissions.levels.meta-site.view.description',
    'no-access': 'users.permissions.levels.meta-site.no-access.description',
  },
};

const permissionDescription = (
  id: typeof OPTION_ORDER[number],
  kind: PermissionOptionsKind,
  t: (key: string) => string,
) => {
  const key = DESCRIPTION_KEYS[kind][id];

  return key ? t(key) : '';
};

export const permissionOptions = (levels: PermissionLevel[], t: TFunction, kind: PermissionOptionsKind) => (
  OPTION_ORDER.flatMap((id) => {
    const level = levels.find(item => item.id === id);

    if (!level) {
      return [];
    }

    return [{
      id,
      value: level.value,
      name: level.name,
      caption: permissionDescription(id, kind, t),
      dataId: PERMISSION_OPTION_DATA_ID,
    }];
  })
);

export const permissionSelectOptions = (
  levels: PermissionLevel[],
  t: TFunction,
  kind: PermissionOptionsKind,
) => ([
  { id: 'permissions', items: permissionOptions(levels, t, kind) },
]);
